import { useState, useEffect } from 'react'
import { useTranslation } from '@/contexts/TranslationContext'

const STORAGE_KEY = 'app:duedate-template'

export function useDueDateTemplate() {
  const { t } = useTranslation()
  const [template, setTemplate] = useState<string>('')
  const [isLoaded, setIsLoaded] = useState(false)

  // Load from localStorage on mount; fallback to i18n message when none exists
  useEffect(() => {
    if (typeof window === 'undefined') return

    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      setTemplate(stored)
      setIsLoaded(true)
      return
    }

    // Use translation key from billing contacts for default duedate message
    const defaultFromI18n = t('billing.contacts.whatsapp.dueDateMessage')
    setTemplate(defaultFromI18n)
    setIsLoaded(true)
  }, [t])

  // Save to localStorage
  const saveTemplate = (newTemplate: string) => {
    if (typeof window === 'undefined') return

    localStorage.setItem(STORAGE_KEY, newTemplate)
    setTemplate(newTemplate)
  }

  // Reset to default
  const resetTemplate = () => {
    if (typeof window === 'undefined') return

    localStorage.removeItem(STORAGE_KEY)
    const defaultFromI18n = t('billing.contacts.whatsapp.dueDateMessage')
    setTemplate(defaultFromI18n)
  }

  return {
    template,
    saveTemplate,
    resetTemplate,
    isLoaded,
  }
}
